import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  FormFeedback,
  Label,
  Input,
  Alert,
  Button,
} from "reactstrap"
import Select from "react-select"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// Redux
import { Link, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

// import images
//  import logoSm from "../../assets/images/logo-sm.png"
import logoSm from "../../../assets/images/logo-sm.png"
import avatar1 from "../../../assets/images/users/avatar-1.jpg"
import { optionGroup, pulaActivityOptions } from "constants/awards"
import {
  addAwardNomination,
  createOrderAwardNomination,
  verifyAwardNominationPayment,
} from "../../../redux/actions/awards"
import ImageCropModal from "components/ImageCropModal"

const Awards = props => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [selectedCategory, setSelectedCategory] = useState(null)
  const [subOptions, setSubOptions] = useState([])
  const [imgSrc, setImgSrc] = useState("")
  const [isOpen, setIsOpen] = useState(false)

  const addAwardNominationScreen = useSelector(
    state => state.screens.event.addAwardNomination
  )
  const createOrderAwardNominationScreen = useSelector(
    state => state.screens.event.createOrderAwardNomination
  )
  const verifyAwardNominationPaymentScreen = useSelector(
    state => state.screens.event.verifyAwardNominationPayment
  )

  useEffect(() => {
    // dispatch({ type: AWARDS_FLOW_INVOKED, payload: { flag: true } })
    // navigate("login", { replace: true })
  }, [])

  useEffect(() => {
    if (addAwardNominationScreen.success) {
      // toast.success(addAwardNominationScreen.message)
      // navigate("/dashboard", { replace: true })
      dispatch(
        createOrderAwardNomination(
          {
            amount: 100,
            currency: "INR",
          },
          token
        )
      )
    }
    if (addAwardNominationScreen.error) {
      toast.error(addAwardNominationScreen.error)
    }
  }, [addAwardNominationScreen])

  useEffect(() => {
    if (createOrderAwardNominationScreen.success) {
      // toast.success(createOrderAwardNominationScreen.message)
      // navigate("/dashboard", { replace: true })
      handlePay()
    }
    if (createOrderAwardNominationScreen.error) {
      toast.error(createOrderAwardNominationScreen.error)
    }
  }, [createOrderAwardNominationScreen])

  useEffect(() => {
    if (verifyAwardNominationPaymentScreen.success) {
      toast.success(verifyAwardNominationPaymentScreen.message)
      // navigate("/dashboard", { replace: true })
    }
    if (verifyAwardNominationPaymentScreen.error) {
      toast.error(verifyAwardNominationPaymentScreen.error)
    }
  }, [verifyAwardNominationPaymentScreen])

  const handleCategoryChange = selected => {
    setSelectedCategory(selected)
    setSubOptions(selected?.subcategories || [])
    validation.setFieldValue("category", selected?.value)
    validation.setFieldValue("sub_category", "") // reset subcategory
  }

  const handleSubCategoryChange = selected => {
    validation.setFieldValue("sub_category", selected?.value)
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      profilePic: null,
      full_name: "",
      email_id: "",
      contact_no: "",
      wa_mobile_no: "",
      fb_profile_link: "",
      fb_page_link: "",
      insta_link: "",
      category: "",
      sub_category: "",
      why_participate: "",
      achievements: "",
      pula_activity: "",
      post_frequency: "",
      review_count: "",
      review_links: ["", "", "", "", ""],
      attended_events: "",
      attended_event_names: "",
      is_org_registered: false,
      turnover_range: "",
      company_age_range: "",
    },
    validationSchema: Yup.object({
      profilePic: Yup.string().required("Please add a Profile Picture"),
      full_name: Yup.string().required("Please Enter Your Full Name"),
      email_id: Yup.string().required("Please Enter Your Email"),
      contact_no: Yup.string().required("Please Enter Your Contact Number"),
      wa_mobile_no: Yup.string().required("Please Enter Your Whatsapp Number"),
      fb_profile_link: Yup.string().url("Invalid URL"),
      fb_page_link: Yup.string().url("Invalid URL"),
      fb_page_link: Yup.string().url("Invalid URL"),
      insta_link: Yup.string().url("Invalid URL"),
      category: Yup.string().required("Please Select a Category"),
      sub_category: Yup.string().required("Please Select a Subcategory"),
      why_participate: Yup.string().required(
        "Please Explain Why You Want to Participate"
      ),
      achievements: Yup.string().required("Please Share Your Achievements"),
      pula_activity: Yup.string().required(
        "Please Describe Your PULA Activity"
      ),
      post_frequency: Yup.string().required(
        "Please Specify Your Post Frequency"
      ),
      review_count: Yup.string().required("Please Specify Your Review Count"),
      review_links: Yup.array()
        .of(Yup.string().url("Must be a valid URL").nullable())
        .test(
          "min-3-links",
          "Please provide at least 3 valid review links",
          arr => arr.filter(val => val && val.trim() !== "").length >= 3
        ),
      attended_events: Yup.string().required(
        "Please Specify If You Attended Any Events"
      ),
      /*   attended_event_names: Yup.string().required(
        "Please List Attended Event Names"
      ), */
      /*    attended_event_names: Yup.string().when("attended_events", {
        is: "Yes",
        then: Yup.string().required("Please specify which events you attended"),
        otherwise: Yup.string().notRequired(),
      }), */
    }),
    onSubmit: values => {
      let requestBody = {
        achievements: "test",
        attended_event_names: "test events",
        attended_events: true, // true - Yes, false - NO
        category: "sustainable_social",
        contact_no: "7040147091",
        is_org_registered: true, // true - Yes, false - NO
        registered_as: "Autskey Pvt Ltd",
        gst_number: "2743403940343",
        turnover_range: "10-30", //  Below 5lakhs, 5-10, 10-30, 30-60, 60+1cr, Above 1cr
        employees_count: 7,
        company_age_range: "Below 2 years", //Below 2 years, 2 - 5 years, 5 - 8 years, 8 - 12 years, 12 - 15 years, Above 15
        email_id: "kranpise@autuskey.com",
        fb_page_link: "",
        fb_profile_link: "https://www.facebook.com/zuck",
        full_name: "Kajal Ranpise",
        insta_link: "https://www.facebook.com/zuck",
        post_frequency: "Twice a week",
        pula_activity: "very_active",
        review_count: "Below 20",
        review_link_1: "Review 1",
        review_link_2: "Review 2",
        review_link_3: "Review 3",
        review_link_4: "",
        review_link_5: "",
        sub_category: "eco_friendly",
        wa_mobile_no: "7040147091",
        why_participate: "test",
      }
      dispatch(addAwardNomination(requestBody, token))
    },
  })

  // const handleSubmit = async value => {

  //   value.review_links?.forEach((link, index) => {
  //     value[`review_link_${index + 1}`] = link
  //   })
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/awards/add-award`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(value),
  //       }
  //     )

  //     if (!response.ok) throw new Error("Award Form failed")

  //     const data = await response.json()
  //     handlePay(data.data)

  //     // navigate("/dashboard", { replace: true });
  //   } catch (error) {
  //     console.error("❌ Award Form error:", error.message)
  //     alert("Unable to add award form.")
  //   }
  // }

  const loadRazorpayScript = () => {
    return new Promise(resolve => {
      if (window.Razorpay) return resolve(true) // already loaded

      const script = document.createElement("script")
      script.src = "https://checkout.razorpay.com/v1/checkout.js"
      script.onload = () => resolve(true)
      script.onerror = () => resolve(false)
      document.body.appendChild(script)
    })
  }

  const handlePay = async submitAwardFormResponse => {

    const scriptLoaded = await loadRazorpayScript()
    if (!scriptLoaded) {
      toast.error(
        "⚠️ Razorpay SDK failed to load. Check your internet connection."
      )
      return
    }
    try {
      const options = {
        key: process.env.REACT_APP_RZRPAY_KEY, // Razorpay Key ID
        amount: 200,
        currency: "INR",
        name: validation.values.full_name,
        description: "Award Payment",
        order_id: "order_98797b",
        handler: async function (response) {
          try {
            const verifyUrl = `${process.env.REACT_APP_API_URL}/awards/verify`
            const res = await fetch(verifyUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                award_nomination_id: submitAwardFormResponse.award_nomination_id,
                amount: process.env.REACT_APP_AWARD_AMOUNT,
                currency: data.order.currency,
                name: submitAwardFormResponse.full_name,
                email_id: submitAwardFormResponse.email_id,
                contact: submitAwardFormResponse.contact_no,
              }),
            })

            const result = await res.json()
            if (result.success) {
              toast.success("🎉 Payment successful!")
              history("/congratulations", { replace: true })
            } else {
              toast.error("❌ Payment failed. Please try again.")
            }
            dispatch(verifyAwardNominationPayment())
            // const verifyUrl = `${process.env.REACT_APP_API_URL}/awards/verify`
            // const res = await fetch(verifyUrl, {
            //   method: "POST",
            //   headers: {
            //     "Content-Type": "application/json",
            //   },
            //   body: JSON.stringify({
            //     razorpay_order_id: response.razorpay_order_id,
            //     razorpay_payment_id: response.razorpay_payment_id,
            //     razorpay_signature: response.razorpay_signature,
            //     award_id: submitAwardFormResponse.award_id,
            //     amount: process.env.REACT_APP_AWARD_AMOUNT,
            //     currency: data.order.currency,
            //     name: submitAwardFormResponse.full_name,
            //     email_id: submitAwardFormResponse.email_id,
            //     contact: submitAwardFormResponse.contact_no,
            //   }),
            // })

            // const result = await res.json()
            // if (result.success) {
            //   toast.success("🎉 Payment successful!")
            //   navigate("/congratulations", { replace: true })
            // } else {
            //   toast.error("❌ Payment failed. Please try again.")
            // }

            /*     if (res.data.success) {
              toast.success("🎉 Payment successful!")
              navigate("/congratulations", { replace: true })
            } else {
              toast.error("❌ Payment failed. Please try again.")
            } */
          } catch (error) {
            console.error("Verification error:", error)
            toast.error("⚠️ Payment verification failed.")
          }
        },
        prefill: {
          name: submitAwardFormResponse.full_name,
          email: submitAwardFormResponse.email_id,
          contact: submitAwardFormResponse.contact_no,
        },
        theme: {
          color: "#3399cc",
        },
      }

      const rzp = new window.Razorpay(options)
      rzp.open()
    } catch (err) {
      console.error("Payment initiation error:", err)
      toast.error("⚠️ Unable to start payment. Please try again later.")
    }
  }

  useEffect(() => {
    if (imgSrc) {
      setIsOpen(true)
    }
  }, [imgSrc])

  function onSelectFile(event) {

    const file = event.target.files[0]
    if (!file) return

    const supported = ["image/jpeg", "image/png", "image/jpg"]
    if (!supported.includes(file.type)) {
      alert("Please upload an image file (jpeg, jpg, png)")
      return
    }

    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader()
      reader.onload = e => {
        setImgSrc(e.target.result)
      }
      reader.readAsDataURL(event.target.files[0])
    }
  }

  function saveImage(file, blobUrl) {
    setImgSrc(null)
    validation.setFieldValue("profilePic", {
      name: file.name,
      url: blobUrl,
    })
  }

  document.title = "Awards | PULA"
  return (
    <>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark text-3xl">
          <i className="fas fa-home"></i>
        </Link>
      </div>
      <div className="awards-dashboard account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={8} xl={8}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-white text-center p-4">
                    <h1 className="text-white pt-4 text-2xl sm:text-3xl md:text-[34px] font-bold uppercase mb-4">
                      PULA BAZAAR Awards
                    </h1>
                    <p className="font-normal text-white text-sm sm:text-base mb-2">
                      Participate in our exciting lucky draw and stand a chance
                      to win amazing prizes.
                      <br />
                      The lucky draw is open for only 2 days.
                    </p>
                    <p className="font-normal text-white text-sm sm:text-base mb-6">
                      🎉 3 winners will be announced each day! 🎉
                    </p>
                    <Link to="/index" className="logo logo-admin">
                      <img src={logoSm} height="50" alt="logo" />
                    </Link>
                  </div>
                </div>
                <CardBody className="p-4">
                  <div className="p-3">
                    {/*    {user ? (
                      <Alert color="success" style={{ marginTop: "13px" }} className="mt-5">
                        Register User Successful
                      </Alert>
                    ) : null} */}
                    <Form
                      className="mt-4"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                      action="#"
                    >
                      <div className="d-flex align-items-center justify-content-center mb-4">
                        <img
                          src={
                            validation.values.profilePic
                              ? validation.values.profilePic.url
                              : avatar1
                          }
                          alt=""
                          className="avatar-xl rounded-circle img-thumbnail"
                        />
                        <Button
                          color="primary"
                          size="sm"
                          className="me-1"
                          onClick={() =>
                            document.getElementById("profilePhoto").click()
                          }
                        >
                          <i className="mdi mdi-pencil"></i> Edit
                        </Button>
                        <input
                          type="file"
                          id="profilePhoto"
                          className="d-none"
                          onChange={e => {
                            onSelectFile(e)
                          }}
                        />
                      </div>
                      <div className="row">
                        <div className="mb-3 col-md-6">
                          <Label className="form-label" htmlFor="full_name">
                            Full Name
                          </Label>
                          <Input
                            name="full_name"
                            className="form-control"
                            placeholder="Enter Full Name"
                            type="text"
                            id="full_name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.full_name || ""}
                            invalid={
                              validation.touched.full_name &&
                              validation.errors.full_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.full_name &&
                          validation.errors.full_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.full_name}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3 col-md-6">
                          <Label className="form-label" htmlFor="email_id">
                            Email
                          </Label>
                          <Input
                            name="email_id"
                            className="form-control"
                            placeholder="Enter Email"
                            type="email_id"
                            id="email_id"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email_id || ""}
                            invalid={
                              validation.touched.email_id &&
                              validation.errors.email_id
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email_id &&
                          validation.errors.email_id ? (
                            <FormFeedback type="invalid">
                              {validation.errors.email_id}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>
                      <div className="row">
                        <div className="mb-3 col-md-6">
                          <Label className="form-label" htmlFor="contact_no">
                            Contact Number
                          </Label>
                          <Input
                            name="contact_no"
                            className="form-control"
                            placeholder="Enter Contact Number"
                            type="tel"
                            id="contact_no"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.contact_no || ""}
                            invalid={
                              validation.touched.contact_no &&
                              validation.errors.contact_no
                                ? true
                                : false
                            }
                          />
                          {validation.touched.contact_no &&
                          validation.errors.contact_no ? (
                            <FormFeedback type="invalid">
                              {validation.errors.contact_no}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3 col-md-6">
                          <Label className="form-label" htmlFor="wa_mobile_no">
                            Whatsapp Number
                          </Label>
                          <Input
                            name="wa_mobile_no"
                            className="form-control"
                            placeholder="Enter Whatsapp Number"
                            type="tel"
                            id="wa_mobile_no"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.wa_mobile_no || ""}
                            invalid={
                              validation.touched.wa_mobile_no &&
                              validation.errors.wa_mobile_no
                                ? true
                                : false
                            }
                          />
                          {validation.touched.wa_mobile_no &&
                          validation.errors.wa_mobile_no ? (
                            <FormFeedback type="invalid">
                              {validation.errors.wa_mobile_no}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>
                      <div className="row">
                        <div className="mb-3 col-md-6">
                          <Label
                            className="form-label"
                            htmlFor="fb_profile_link"
                          >
                            Facebook Profile Link
                          </Label>
                          <Input
                            name="fb_profile_link"
                            className="form-control"
                            placeholder="Enter Facebook Profile Link"
                            type="url"
                            id="fb_profile_link"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.fb_profile_link || ""}
                            invalid={
                              validation.touched.fb_profile_link &&
                              validation.errors.fb_profile_link
                                ? true
                                : false
                            }
                          />
                          {validation.touched.fb_profile_link &&
                          validation.errors.fb_profile_link ? (
                            <FormFeedback type="invalid">
                              {validation.errors.fb_profile_link}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3 col-md-6">
                          <Label className="form-label" htmlFor="fb_page_link">
                            Facebook Page Link
                          </Label>
                          <Input
                            name="fb_page_link"
                            className="form-control"
                            placeholder="Enter Facebook Page Link"
                            type="url"
                            id="fb_page_link"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.fb_page_link || ""}
                            invalid={
                              validation.touched.fb_page_link &&
                              validation.errors.fb_page_link
                                ? true
                                : false
                            }
                          />
                          {validation.touched.fb_page_link &&
                          validation.errors.fb_page_link ? (
                            <FormFeedback type="invalid">
                              {validation.errors.fb_page_link}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>
                      <div className="row">
                        <div className="mb-3 col-md-6">
                          <Label className="form-label" htmlFor="insta_link">
                            Instagram Page Link
                          </Label>
                          <Input
                            name="insta_link"
                            className="form-control"
                            placeholder="Enter Instagram Page Link"
                            type="url"
                            id="insta_link"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.insta_link || ""}
                            invalid={
                              validation.touched.insta_link &&
                              validation.errors.insta_link
                                ? true
                                : false
                            }
                          />
                          {validation.touched.insta_link &&
                          validation.errors.insta_link ? (
                            <FormFeedback type="invalid">
                              {validation.errors.insta_link}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </div>
                      <div className="row">
                        <div className="mb-3 col-md-6">
                          <Label className="form-label" htmlFor="category">
                            Which category would you like to apply for?
                          </Label>

                          <Select
                            id="category"
                            name="category"
                            value={selectedCategory}
                            onChange={handleCategoryChange}
                            options={optionGroup}
                            classNamePrefix="select2-selection"
                          />
                          {validation.touched.category &&
                            validation.errors.category && (
                              <FormFeedback className="d-block" type="invalid">
                                {validation.errors.category}
                              </FormFeedback>
                            )}
                        </div>
                        <div className="mb-3 col-md-6">
                          <Label className="form-label" htmlFor="sub_category">
                            Subcategory
                          </Label>

                          <Select
                            id="sub_category"
                            name="sub_category"
                            value={subOptions.find(
                              option =>
                                option.value === validation.values.sub_category
                            )}
                            onChange={handleSubCategoryChange}
                            options={subOptions}
                            isDisabled={!selectedCategory}
                            classNamePrefix="select2-selection"
                          />
                          {validation.touched.sub_category &&
                            validation.errors.sub_category && (
                              <FormFeedback className="d-block" type="invalid">
                                {validation.errors.sub_category}
                              </FormFeedback>
                            )}
                        </div>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="why_participate">
                          Why would you want to participate?
                        </Label>

                        <textarea
                          name="why_participate"
                          id="why_participate"
                          className={`form-control ${
                            validation.touched.why_participate &&
                            validation.errors.why_participate
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.why_participate || ""}
                        />

                        {validation.touched.why_participate &&
                        validation.errors.why_participate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.why_participate}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="achievements">
                          Achievements till date?
                        </Label>

                        <textarea
                          name="achievements"
                          id="achievements"
                          className={`form-control ${
                            validation.touched.achievements &&
                            validation.errors.achievements
                              ? "is-invalid"
                              : ""
                          }`}
                          rows="3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.achievements || ""}
                        />

                        {validation.touched.achievements &&
                          validation.errors.achievements && (
                            <FormFeedback type="invalid">
                              {validation.errors.achievements}
                            </FormFeedback>
                          )}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label" htmlFor="pula_activity">
                          How active are you on the PULA FB group?
                        </Label>

                        <Select
                          id="pula_activity"
                          name="pula_activity"
                          options={pulaActivityOptions}
                          value={pulaActivityOptions.find(
                            opt => opt.value === validation.values.pula_activity
                          )}
                          onChange={selectedOption => {
                            validation.setFieldValue(
                              "pula_activity",
                              selectedOption?.value
                            )
                          }}
                          onBlur={() =>
                            validation.setFieldTouched("pula_activity", true)
                          }
                          classNamePrefix="select2-selection"
                        />

                        {validation.touched.pula_activity &&
                          validation.errors.pula_activity && (
                            <FormFeedback className="d-block" type="invalid">
                              {validation.errors.pula_activity}
                            </FormFeedback>
                          )}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label mb-3 d-flex">
                          How often do you post?
                        </Label>

                        {[
                          "Twice a week",
                          "Twice a month",
                          "Once 3-4 months",
                          "Very rare",
                        ].map((option, index) => (
                          <div
                            className="form-check form-check-inline"
                            key={index}
                          >
                            <input
                              className={`form-check-input ${
                                validation.touched.post_frequency &&
                                validation.errors.post_frequency
                                  ? "is-invalid"
                                  : ""
                              }`}
                              type="radio"
                              id={`post_frequency_${index}`}
                              name="post_frequency"
                              value={option}
                              checked={
                                validation.values.post_frequency === option
                              }
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`post_frequency_${index}`}
                            >
                              {option}
                            </label>
                          </div>
                        ))}

                        {validation.touched.post_frequency &&
                          validation.errors.post_frequency && (
                            <div className="invalid-feedback d-block">
                              {validation.errors.post_frequency}
                            </div>
                          )}
                      </div>
                      <div className="mb-3">
                        <Label className="form-label mb-3 d-flex">
                          How many reviews would you have on PULA?
                        </Label>

                        {[
                          "Below 20",
                          "Below 50",
                          "Below 100",
                          "Lost the count",
                        ].map((option, index) => (
                          <div
                            className="form-check form-check-inline"
                            key={index}
                          >
                            <input
                              className={`form-check-input ${
                                validation.touched.review_count &&
                                validation.errors.review_count
                                  ? "is-invalid"
                                  : ""
                              }`}
                              type="radio"
                              id={`review_count_${index}`}
                              name="review_count"
                              value={option}
                              checked={
                                validation.values.review_count === option
                              }
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`review_count_${index}`}
                            >
                              {option}
                            </label>
                          </div>
                        ))}

                        {validation.touched.review_count &&
                          validation.errors.review_count && (
                            <div className="invalid-feedback d-block">
                              {validation.errors.review_count}
                            </div>
                          )}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">
                          Please share links of a few of your reviews (minimum
                          3)
                        </Label>

                        {validation.values.review_links.map((link, index) => (
                          <Input
                            key={index}
                            type="text"
                            name={`review_links[${index}]`}
                            className={`form-control mb-2 ${
                              validation.touched.review_links &&
                              validation.errors.review_links &&
                              validation.errors.review_links[index]
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder={`Link ${index + 1}`}
                            value={validation.values.review_links[index]}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                          />
                        ))}

                        {typeof validation.errors.review_links === "string" && (
                          <FormFeedback className="d-block" type="invalid">
                            {validation.errors.review_links}
                          </FormFeedback>
                        )}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label d-flex">
                          Have you attended any of PULA's events?{" "}
                        </Label>

                        {["Yes", "No"].map((option, index) => (
                          <div
                            className="form-check form-check-inline"
                            key={index}
                          >
                            <input
                              className={`form-check-input ${
                                validation.touched.attended_events &&
                                validation.errors.attended_events
                                  ? "is-invalid"
                                  : ""
                              }`}
                              type="radio"
                              id={`attended_events_${index}`}
                              name="attended_events"
                              value={option}
                              checked={
                                validation.values.attended_events === option
                              }
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`attended_events_${index}`}
                            >
                              {option}
                            </label>
                          </div>
                        ))}

                        {validation.touched.attended_events &&
                          validation.errors.attended_events && (
                            <div className="invalid-feedback d-block">
                              {validation.errors.attended_events}
                            </div>
                          )}
                      </div>
                      {validation.values.attended_events === "Yes" && (
                        <div className="mb-3">
                          <Label
                            className="form-label"
                            htmlFor="attended_event_names"
                          >
                            Which ones?
                          </Label>
                          <Input
                            name="attended_event_names"
                            className="form-control"
                            placeholder="Enter Which Events You Attended"
                            type="text"
                            id="attended_event_names"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.attended_event_names || ""}
                            invalid={
                              validation.touched.attended_event_names &&
                              validation.errors.attended_event_names
                                ? true
                                : false
                            }
                          />
                          {validation.touched.attended_event_names &&
                          validation.errors.attended_event_names ? (
                            <FormFeedback type="invalid">
                              {validation.errors.attended_event_names}
                            </FormFeedback>
                          ) : null}
                        </div>
                      )}

                      <div className="mb-3 row">
                        <div className="col-12 text-center">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} PULA. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Autuskey
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <ImageCropModal
          isOpen={isOpen}
          imgSrc={imgSrc}
          saveImage={saveImage}
          toggle={() => setIsOpen(false)}
        />
      </div>
    </>
  )
}
export default Awards
